export const cbBenefits = [
  {
    image: {
      url:
        'https://cms.1800accountant.com/wp-content/uploads/2018/11/dedicated-bookkeeper-screen@2x.png',
      alt: 'Bookkeeping app iPhone screen',
    },
    benefit_title: 'Rely on a Team of Bookkeeping Professionals',
    benefit_sub_title: 'Our accounting experts will:',
    benefit_list: [
      { benefit_list_item: 'Get you organized by setting up your Chart of Accounts' },
      {
        benefit_list_item:
          'Streamline your work by syncing all your business transactions',
      },
      {
        benefit_list_item:
          'Provide peace of mind as they answer any questions you have along the way',
      },
    ],
  },
  {
    image: {
      url:
        'https://cms.1800accountant.com/wp-content/uploads/2018/11/get-paid-faster-screen@2x.png',
      alt: 'Invoicing app iPhone screen',
    },
    benefit_title: 'Get Paid Faster with Online Invoicing',
    benefit_sub_title: 'ClientBooks enables you to:',
    benefit_list: [
      {
        benefit_list_item:
          'Collect payments faster by sending invoices from anywhere on any device',
      },
      {
        benefit_list_item:
          'Strengthen relationships with your customers as you track your payments',
      },
      {
        benefit_list_item:
          'Maximize your earning potential as you allocate hours to individual projects in real time',
      },
    ],
  },
  {
    image: {
      url:
        'https://cms.1800accountant.com/wp-content/uploads/2018/11/income-expenses-screen@2x.png',
      alt: 'Income and Expenses iPhone screenshot',
    },
    benefit_title: 'Easily Manage Income & Expenses',
    benefit_sub_title: 'Use ClientBooks to:',
    benefit_list: [
      { benefit_list_item: 'Record financial transactions and categorize expenses' },
      {
        benefit_list_item:
          'Take pictures of receipts with your phone to make uploading and tracking of business expenses a breeze.',
      },
      {
        benefit_list_item:
          'Gain insights into your business by generating reports to see where you are spending your money',
      },
    ],
  },
];